import React from 'react';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import { useStyles } from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import {
  DragAndDropArea,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/components/dragAndDropArea';

export const GroupingByProjectEntity: React.FC<{complexName: string}> = ({ complexName }) => {
  const styles = useStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);

  return (
    <GroupWrapper
      name={complexName}
      actions={(
        <GroupWrapperFiltersAction
          collapseState={collapseState}
          onCollapse={(state) => {
            setCollapseState(state);
          }}
        />
      )}
    >
      { collapseState === GroupWrapperCollapseState.OPEN && (
        <div className={styles.wrapper}>
          <DragAndDropArea />
        </div>
      ) }
    </GroupWrapper>
  );
};
